import type { ReactNode } from 'react';
import { TabPanel } from '../NotesDisplay/NotesDisplay.styles';

interface TabPanelProps {
  children?: ReactNode;
  index: number;
  value: number;
}

const NoteTabPanel = ({ children, value, index, ...other }: TabPanelProps) => (
  <TabPanel
    role="tabpanel"
    hidden={value !== index}
    id={`notes-display-tabpanel-${index}`}
    aria-labelledby={`notes-display-tab-${index}`}
    {...other}
  >
    {value === index && children}
  </TabPanel>
);

export default NoteTabPanel;
